/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import useSize from '../../hooks/useSize'
import { TableConcessionaries } from './components/TableConcessionaries'

const concessionariesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Início',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ConcessionariesPage: FC = () => {
  return (
    <div className='column g-5 g-xl-8'>
      <TableConcessionaries className='card-xl-stretch mb-xl-8' />
    </div>
  )
}

const ConcessionariesWrapper: FC = () => {
  const {width} = useSize()

  return (
    <>
      <PageTitle breadcrumbs={concessionariesBreadcrumbs}>
        {width < 1200 ? 'Concessionárias' : 'Catálogo de Concessionárias'}
      </PageTitle>
      <ConcessionariesPage />
    </>
  )
}

export {ConcessionariesWrapper}
